import { AdditionalFilter } from './additional-filter';

export class LinkedUpdateFilterModel extends AdditionalFilter {
    fromDate: string | null;
    toDate: string | null;
    regulator: string[] | null;
    rulebook: string;

    constructor() {
        super();
        this.regulator = null;
        this.fromDate = null;
        this.toDate = null;
        this.rulebook = '';
    }
}
